<div
  class="radio radio--{{ view }}"
  [ngClass]="{ 'radio--disabled': disabled }"
>
  <input
    class="radio__control"
    type="radio"
    [id]="idRadio"
    [name]="name"
    [value]="valueRadio"
    [disabled]="disabled"
    [(ngModel)]="value"
  />
  <label
    class="radio__label"
    [for]="idRadio"
  >
    <span class="radio__text radio__text--{{ labelSize }}">{{ label }}</span>
  </label>
</div>
